/**
 * Route Error Component
 *
 * Displays errors that occur during routing (404, invalid params, etc.)
 */

import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";
import {
  SystemCardShell,
  SystemCardHeading,
  SystemCardActions,
  SystemCardPrimary,
  SystemCardSecondary,
} from "@/components/shared/layout";

function RouteError() {
  const error = useRouteError();

  let title = "Something went wrong";
  let message = "An unexpected error occurred.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Page not found";
      message = "The page you're looking for doesn't exist.";
    } else if (error.status === 403) {
      title = "Access denied";
      message = "You don't have permission to access this page.";
    } else {
      title = `Error ${error.status}`;
      message = error.statusText || "An error occurred.";
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <SystemCardShell>
      <SystemCardHeading eyebrow={isRouteErrorResponse(error) ? `Error ${error.status}` : "Error"} title={title}>
        {message}
      </SystemCardHeading>
      <SystemCardActions>
        <SystemCardPrimary asChild>
          <Link to="/dashboard">Go to dashboard</Link>
        </SystemCardPrimary>
        <SystemCardSecondary onClick={() => window.history.back()}>Go back</SystemCardSecondary>
      </SystemCardActions>
    </SystemCardShell>
  );
}

export function NotFound() {
  return (
    <SystemCardShell>
      <SystemCardHeading eyebrow="Error 404" title="Page not found">
        The page you're looking for doesn't exist or has been moved.
      </SystemCardHeading>
      <SystemCardActions>
        <SystemCardPrimary asChild>
          <Link to="/dashboard">Go to dashboard</Link>
        </SystemCardPrimary>
        <SystemCardSecondary asChild>
          <Link to="/sign-in">Sign in</Link>
        </SystemCardSecondary>
      </SystemCardActions>
    </SystemCardShell>
  );
}
